import React from 'react';
import Layout from '../utils/layout';
import SignIn from '../components/scenes/Auth/scenes/SignIn/SignIn';

const SignInPage = () => (
  <Layout hideNav>
    <SignIn />
  </Layout>
);

export default SignInPage;
